import React from "react";
import { Tooltip } from "antd";
import {
  ClockCircleOutlined,
  GlobalOutlined,
  TeamOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { formatDateByLocale } from "../../../utils/dateFormat";

export const getVisibilityInfo = (row, groups = []) => {
  const groupId = row.visibilityGroupId || row.group?._id;
  const groupName =
    row.group?.name ||
    groups.find((g) => g._id === row.visibilityGroupId)?.name ||
    "Group";

  if (
    row.visibility === "PUBLIC" ||
    row.visibilityType === "ALL_SUBSCRIBERS"
  ) {
    return {
      icon: GlobalOutlined,
      label: "All subscribers",
      type: "all_subscribers",
    };
  }
  if (row.visibilityType === "GROUP") {
    return {
      icon: TeamOutlined,
      label: groupName,
      type: "group",
      groupId,
    };
  }
  if (row.visibilityType === "INVITE_ONLY") {
    return {
      icon: ShareAltOutlined,
      label: "Invite only",
      type: "invite_only",
    };
  }
  return {
    icon: GlobalOutlined,
    label: "All subscribers",
    type: "all_subscribers",
  };
};

export const getStatusDisplay = (status) => {
  switch (status) {
    case "PUBLISHED":
      return { label: "Published", tone: "published" };
    case "SCHEDULED":
      return { label: "Scheduled", tone: "scheduled" };
    case "HIDDEN":
      return { label: "Hidden", tone: "draft" };
    case "DRAFTED":
    default:
      return { label: "Drafted", tone: "draft" };
  }
};

export const formatScheduledStatusTime = (scheduledAt) =>
  dayjs(scheduledAt).format("M/D, h:mm A");

export default function VisibleToCell({ status, row, groups = [], navigate }) {
  const { icon: VisibilityIcon, label, type, groupId } = getVisibilityInfo(
    row,
    groups
  );
  const { label: statusLabel, tone } = getStatusDisplay(status);

  const handleGroupClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (groupId && navigate) {
      navigate(`/SubscriberManager?tabName=groups&groupId=${groupId}`);
    }
  };

  return (
    <div className="challenge-visible-cell">
      <span
        className={`challenge-visible-icon challenge-visible-icon--${tone}`}
      >
        <VisibilityIcon />
      </span>
      <div className="challenge-visible-text">
        <div className="challenge-visible-label">
          {type === "group" && groupId ? (
            <a
              className="challenge-visible-group-link"
              href={`/SubscriberManager?tabName=groups&groupId=${groupId}`}
              onClick={handleGroupClick}
            >
              {label}
            </a>
          ) : (
            label
          )}
        </div>
        <div
          className={`challenge-visible-status challenge-visible-status--${tone}`}
        >
          <span>{statusLabel}</span>
          {status === "SCHEDULED" && row.scheduledAt && (
            <Tooltip title={formatDateByLocale(row.scheduledAt)}>
              <span className="challenge-visible-scheduled-time">
                <span className="challenge-visible-scheduled-sep">·</span>
                <ClockCircleOutlined />
                {formatScheduledStatusTime(row.scheduledAt)}
              </span>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}

export const createVisibleToColumn = ({ groups = [], navigate } = {}) => ({
  title: "Visible to",
  dataIndex: "status",
  key: "status",
  render: (status, row) => (
    <VisibleToCell
      status={status}
      row={row}
      groups={groups}
      navigate={navigate}
    />
  ),
});
